import { ProductVariantsTab } from './ProductVariantsTab';

export default ProductVariantsTab;



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/ProductVariantsTab/index.ts